export default __webpack_public_path__ + "static/media/self-delivery-method.4036a660.png";